(() => {
  async function addToCartInPlace(root, form, button) {
    if (button.dataset.ey3Busy === 'true') return;
    const label = root.querySelector('[data-ey3-add-label]');
    const selected = root.querySelector('[data-ey3-variant]')?.selectedOptions?.[0];
    const selectedAvailable = !selected || selected.dataset.ey3Available === 'true';
    button.dataset.ey3Busy = 'true';
    button.disabled = true;
    if (label) label.textContent = 'جاري الإضافة...';
    let deferred;
    let added = false;
    const rootUrl = window.Shopify?.routes?.root || '/';
    try {
      const { CartLinesUpdateEvent } = await import('https://cdn.shopify.com/storefront/standard-events.js');
      const formData = new FormData(form);
      const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), item => item.dataset.sectionId))];
      if (sections.length) formData.set('sections', sections.slice(0, 5).join(','));
      formData.set('sections_url', window.location.pathname);
      deferred = CartLinesUpdateEvent.createPromise();
      deferred.promise.catch(() => {});
      form.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 }],
        promise: deferred.promise
      }));
      const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST', headers: {Accept: 'application/json'}, body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'تعذر إضافة المنتج للسلة');
      added = true;
      const cartResponse = await fetch(rootUrl + 'cart.js', {cache: 'no-store'});
      if (!cartResponse.ok) throw new Error('تعذر تحديث السلة');
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {items: cart.items, sections: result.sections, source:'easeyou-product-form',
          sourceId: form.id, itemCount: Number(formData.get('quantity')) || 1, didError:false}
      });
      if (label) label.textContent = 'أضف للسلة';
    } catch (error) {
      deferred?.reject(error);
      console.error('[Ease You] Add to cart failed', error);
      // A successful add must never be retried automatically, even if rendering fails.
      if (added) {
        if (label) label.textContent = 'تمت الإضافة — عرض السلة';
        window.location.assign(rootUrl + 'cart');
        return;
      }
      if (label) label.textContent = error?.message || 'حاول مرة ثانية';
      window.setTimeout(() => { if (label) label.textContent = 'أضف للسلة'; }, 2200);
    } finally {
      button.dataset.ey3Busy = 'false';
      button.disabled = !selectedAvailable;
    }
  }

  function initialize(root) {
    if (root.dataset.ey3Ready) return;
    root.dataset.ey3Ready = 'true';

    const mainImage = root.querySelector('[data-ey3-main-image]');
    const mainPhoto = root.querySelector('.ey3-main-photo');
    const thumbnails = Array.from(root.querySelectorAll('[data-ey3-image]'));
    const thumbnailRail = root.querySelector('.ey3-thumbnails');
    const activeIndex = () => Math.max(0, thumbnails.findIndex(b => b.classList.contains('is-active')));
    const chooseImage = button => {
      if (!mainImage) return;
      mainImage.src = button.dataset.ey3Image;
      mainImage.removeAttribute('srcset');
      mainImage.alt = button.dataset.ey3Alt || '';
      thumbnails.forEach(other => {
        const active = other === button;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', String(active));
      });
      if (mainPhoto && thumbnails.length > 1) {
        mainPhoto.setAttribute('aria-label',
          'صورة ' + (activeIndex() + 1) + ' من ' + thumbnails.length +
          ' — اسحب يمين أو يسار لتغيير الصورة');
      }
      if (thumbnailRail) {
        const item = button.getBoundingClientRect();
        const rail = thumbnailRail.getBoundingClientRect();
        const delta = item.left < rail.left + 6 ? item.left - rail.left - 6
          : item.right > rail.right - 6 ? item.right - rail.right + 6 : 0;
        if (delta) thumbnailRail.scrollBy({left: delta, behavior: 'smooth'});
      }
    };
    thumbnails.forEach(button => button.addEventListener('click', () => chooseImage(button)));

    if (mainImage && mainPhoto && thumbnails.length > 1) {
      mainImage.draggable = false;
      mainPhoto.classList.add('ey3-swipe-ready');
      mainPhoto.tabIndex = 0;
      mainPhoto.setAttribute('role', 'group');
      mainPhoto.setAttribute('aria-label',
        'صورة 1 من ' + thumbnails.length + ' — اسحب يمين أو يسار لتغيير الصورة');

      const changeBy = step => {
        const index = Math.max(0, Math.min(thumbnails.length - 1, activeIndex() + step));
        if (index !== activeIndex()) thumbnails[index].click();
      };
      // Passive native touch events: NEVER capture pointers or block page scrolling.
      const changeOnHorizontalSwipe = (dx, dy) => {
        if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          changeBy(dx < 0 ? 1 : -1);
        }
      };
      let touchStart = null;
      mainPhoto.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { touchStart = null; return; }
        const touch = event.touches[0];
        touchStart = {x: touch.clientX, y: touch.clientY, id: touch.identifier};
      }, {passive: true});
      mainPhoto.addEventListener('touchend', event => {
        if (!touchStart) return;
        const touch = Array.from(event.changedTouches)
          .find(t => t.identifier === touchStart.id);
        if (touch) changeOnHorizontalSwipe(
          touch.clientX - touchStart.x, touch.clientY - touchStart.y);
        touchStart = null;
      }, {passive: true});
      mainPhoto.addEventListener('touchcancel', () => { touchStart = null; },
        {passive: true});

      // Mouse dragging is independent of touch and never captures scroll gestures.
      let mouseStart = null;
      mainPhoto.addEventListener('mousedown', event => {
        if (event.button === 0) {
          mouseStart = {x: event.clientX, y: event.clientY};
        }
      });
      window.addEventListener('mouseup', event => {
        if (!mouseStart) return;
        const start = mouseStart;
        mouseStart = null;
        if (event.button === 0) changeOnHorizontalSwipe(
          event.clientX - start.x, event.clientY - start.y);
      });
      mainPhoto.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        changeBy(event.key === 'ArrowLeft' ? 1 : -1);
      });
    }

    root.querySelectorAll('[data-ey3-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        const input = root.querySelector('input[name="quantity"]');
        if (!input) return;
        const current = Number(input.value) || 1;
        input.value = String(Math.max(1, Math.min(20, current + Number(button.dataset.ey3Quantity))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Lightweight same-product quantity upgrades. Existing Shopify & EasySell buttons remain native.
    // Pack variants encode exact order totals; no global discount codes or cart writes.
    const tierGroup = root.querySelector('[data-ey4-tiers]');
    if (tierGroup) {
      const form = root.querySelector('form.ey3-form');
      const idField = form?.querySelector('input[name="id"]');
      const quantityField = form?.querySelector('input[name="quantity"]');
      const ids = {
        1: tierGroup.dataset.ey4VariantOne,
        2: tierGroup.dataset.ey4VariantTwo,
        3: tierGroup.dataset.ey4VariantThree
      };
      const prices = {
        1: tierGroup.dataset.ey4PriceOne,
        2: tierGroup.dataset.ey4PriceTwo,
        3: tierGroup.dataset.ey4PriceThree
      };
      const selectPack = () => {
        const count = Number(tierGroup.querySelector('input[name="ey4_offer"]:checked')?.value || 1);
        if (idField && ids[count] && idField.value !== ids[count]) {
          idField.value = ids[count];
          idField.dispatchEvent(new Event('change', {bubbles: true}));
        }
        if (quantityField && quantityField.value !== '1') {
          quantityField.value = '1';
          quantityField.dispatchEvent(new Event('change', {bubbles: true}));
        }
        const visiblePrice = root.querySelector('[data-ey3-price]');
        if (visiblePrice && prices[count]) visiblePrice.textContent = prices[count] + ' د.ك';
        root.dataset.ey4Multi = String(count > 1);
      };
      tierGroup.addEventListener('change', event => {
        if (event.target.matches('input[name="ey4_offer"]')) selectPack();
      });
      selectPack();
    }

    const variants = root.querySelector('[data-ey3-variant]');
    if (variants) variants.addEventListener('change', () => {
      const option = variants.selectedOptions[0];
      const available = option.dataset.ey3Available === 'true';
      const price = root.querySelector('[data-ey3-price]');
      const add = root.querySelector('[data-ey3-add]');
      const addLabel = root.querySelector('[data-ey3-add-label]');
      if (price) price.textContent = option.dataset.ey3Price;
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'أضف للسلة' : 'غير متوفر حالياً';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variants.value);
      history.replaceState({}, '', url);
    });

    const form = root.querySelector('form.ey3-form');
    const addButton = root.querySelector('[data-ey3-add]');
    if (form && addButton) {
      // Explicit click handler keeps Shopify/EasySell buttons from hijacking Add to Cart.
      addButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        addToCartInPlace(root, form, addButton);
      });
      // Keyboard Enter is an alternate submit path; keep the same single AJAX implementation.
      form.addEventListener('submit', event => {
        if (event.submitter && event.submitter !== addButton) return;
        event.preventDefault();
        addToCartInPlace(root, form, addButton);
      });
    }
  }

  function start() {
    document.querySelectorAll('[data-ey3-product]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
